import styled from 'styled-components';
import { theme } from '@jadwalh/ui';

export const RadioWrapper = styled.div`
  label {
    display: flex;
    gap: 8px;
    font-weight: 600;
    font-size: 13px;
    margin-bottom: 0;
  }

  input {
    position: relative;
    appearance: none;
    width: 15px;
    height: 15px;
    border-radius: 1.25rem;
    margin: 0px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    background-color: ${theme.colours.white} !important;
    border: 0.5px solid ${theme.colours.newOutline};

    &:checked::after {
      content: '\\2713';
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${theme.colours.blackText} !important;
      width: 100%;
      height: 100%;
      margin: 20% auto;
      border-radius: 50%;
      border: 0.5px solid ${theme.colours.blackText} !important;
      font-size: 10px;
    }
  }
  p {
    width: calc(100% - 20px);
  }

  /* input[type='radio']:before {
    content: '';
    display: block;
    width: 45%;
    height: 45%;
    margin: 20% auto;
    border-radius: 50%;
  } */

  input[type='radio']:checked:before {
    background: #fff;
  }
`;
